<!---modules1-Main-->
<template>
  <router-view />
</template>
<script>
export default {
  name: 'Main',
  components: {},
  data () {
    return {}
  },
  methods: {}
}

</script>